/**
 * Per-user account quotas for Firestore-backed resources.
 *
 * Game-rule deck construction limits (40 main, 3 copies, etc.) live in
 * `DECK_LIMITS` (`src/types/deck.ts`). Pocket layout and page caps for binders
 * live in `binderUtils.ts`.
 */

export const USER_LIMITS = {
  MAX_DECKS_PER_USER: 50,
  /** Rolling version checkpoints per deck (manual Save / leave prompt). */
  MAX_VERSIONS_PER_DECK: 50,
  /** Custom binders only — set binders are capped at one per set code. */
  MAX_CUSTOM_BINDERS_PER_USER: 3,
} as const;

export function isAtDeckLimit(existingDeckCount: number): boolean {
  return existingDeckCount >= USER_LIMITS.MAX_DECKS_PER_USER;
}

export function deckLimitReachedMessage(): string {
  return `You've reached the limit of ${USER_LIMITS.MAX_DECKS_PER_USER} decks. Delete a deck to create a new one.`;
}

export function countCustomBinders<T extends { kind: string }>(binders: readonly T[]): number {
  return binders.filter((binder) => binder.kind === 'custom').length;
}

export function isAtCustomBinderLimit(existingCustomBinderCount: number): boolean {
  return existingCustomBinderCount >= USER_LIMITS.MAX_CUSTOM_BINDERS_PER_USER;
}

export function customBinderLimitReachedMessage(): string {
  return `You've reached the limit of ${USER_LIMITS.MAX_CUSTOM_BINDERS_PER_USER} custom binders. Delete a binder to create a new one.`;
}
